import styles from "./styles.module.css"
import BookRemoveButton from "../BookRemoveButton";
import BookUpdateButton from "../BookUpdateButton";
import BookReadButton from "../BookReadButton";
import BookRestoreButton from "../BookRestoreButton";
import BookMakeFreeButton from "../BookMakeFreeButton";
import BookMakePaidButton from "../BookMakePaidButton";


export default function BookItem({ bookData, count, collection, isVirtual, updateTableData }) {

    return (

        <div className={styles.optionsButtons}>
            {isVirtual && <BookReadButton bookId={bookData.id} />}
            <BookUpdateButton updateTableData={updateTableData} collectionRef={collection} bookData={bookData} isVirtual={isVirtual} />
            {
                bookData.active ?
                    <BookRemoveButton updateTableData={updateTableData} collection={collection} bookId={bookData.id} isVirtual={isVirtual} />
                    :
                    <BookRestoreButton updateTableData={updateTableData} collection={collection} bookId={bookData.id} isVirtual={isVirtual} />
            }
            {
                bookData.free ?
                    <BookMakePaidButton updateTableData={updateTableData} collection={collection} bookId={bookData.id} isVirtual={isVirtual} />
                    :
                    <BookMakeFreeButton updateTableData={updateTableData} collection={collection} bookId={bookData.id} isVirtual={isVirtual} />
            }
        </div>

    );
}